var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24.998,
    r: 25,
    fill: "url(#paint0_linear_752_78170)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_78170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8479 25.9687C38.8479 27.0508 38.7228 28.1037 38.4857 29.114C38.2519 30.1131 37.9088 31.0707 37.4692 31.9734C37.0907 32.7511 36.6405 33.4878 36.1281 34.1751C35.0987 35.5549 33.8159 36.7346 32.3492 37.6456C32.0953 37.8038 31.8357 37.9534 31.571 38.0942C29.6457 39.1224 27.4468 39.7049 25.1116 39.7049C22.7764 39.7049 20.5775 39.1224 18.6522 38.0942C18.3875 37.9534 18.1279 37.8037 17.874 37.6456C16.4073 36.7345 15.1245 35.5549 14.0951 34.1751C12.7338 32.3502 11.8149 30.1759 11.4981 27.8111C11.4347 27.3412 11.3955 26.8647 11.3815 26.3814C11.3776 26.2439 11.3753 26.1066 11.3753 25.9687C11.3753 24.6231 11.5688 23.3218 11.9298 22.0923C12.0734 21.6039 12.2432 21.1268 12.4378 20.6626C12.8729 19.6253 13.4313 18.652 14.0951 17.7622C15.1066 16.4071 16.3619 15.2443 17.7966 14.3405C19.889 13.0213 22.3616 12.2515 25.0135 12.233C25.046 12.2324 25.0791 12.2324 25.1116 12.2324C27.8005 12.2324 30.3084 13.005 32.4266 14.3405C32.6699 14.4936 32.9076 14.6545 33.1403 14.8227C34.2802 15.6441 35.2882 16.637 36.1281 17.7622C36.8447 18.7232 37.439 19.7812 37.8869 20.9126C38.0714 21.3774 38.2312 21.8545 38.364 22.3428C38.4918 22.8099 38.595 23.287 38.6729 23.7725C38.7486 24.2418 38.8002 24.7184 38.8266 25.2022C38.8406 25.4557 38.8479 25.7113 38.8479 25.9687Z",
    fill: "#F8ADBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1281 14.3398V34.1745C35.0987 35.5543 33.8159 36.7339 32.3492 37.645C32.0952 37.8031 31.8356 37.9528 31.571 38.0935C29.6457 39.1217 27.4467 39.7043 25.1116 39.7043C22.7764 39.7043 20.5775 39.1217 18.6522 38.0935C18.3875 37.9528 18.1279 37.803 17.874 37.645C16.4072 36.7339 15.1245 35.5543 14.0951 34.1745L14.0951 14.3398L36.1281 14.3398Z",
    fill: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 12.5137C16.4009 12.5137 15.9491 12.9655 15.9491 13.5228V16.3034C15.9491 16.8608 16.4009 17.3126 16.9583 17.3126C17.5156 17.3126 17.9674 16.8608 17.9674 16.3034V13.5228C17.9674 12.9654 17.5156 12.5137 16.9583 12.5137Z",
    fill: "#F17A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2646 12.5137C32.7073 12.5137 32.2555 12.9655 32.2555 13.5228V16.3034C32.2555 16.8608 32.7073 17.3126 33.2646 17.3126C33.8219 17.3126 34.2737 16.8608 34.2737 16.3034V13.5228C34.2737 12.9654 33.8219 12.5137 33.2646 12.5137Z",
    fill: "#F17991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1114 12.5137C24.5541 12.5137 24.1023 12.9655 24.1023 13.5228V16.3034C24.1023 16.8608 24.5541 17.3126 25.1114 17.3126C25.6688 17.3126 26.1206 16.8608 26.1206 16.3034V13.5228C26.1206 12.9654 25.6687 12.5137 25.1114 12.5137Z",
    fill: "#F17991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0348 12.5137C20.4775 12.5137 20.0257 12.9655 20.0257 13.5228V16.3034C20.0257 16.8608 20.4775 17.3126 21.0348 17.3126C21.5922 17.3126 22.044 16.8608 22.044 16.3034V13.5228C22.044 12.9654 21.5922 12.5137 21.0348 12.5137Z",
    fill: "#F17991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.188 12.5137C28.6306 12.5137 28.1788 12.9655 28.1788 13.5228V16.3034C28.1788 16.8608 28.6306 17.3126 29.188 17.3126C29.7453 17.3126 30.1971 16.8608 30.1971 16.3034V13.5228C30.1972 12.9654 29.7453 12.5137 29.188 12.5137Z",
    fill: "#F17991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7714 16.3035V13.5229C16.7714 13.1121 17.0172 12.7594 17.3694 12.6018C17.2437 12.5457 17.1048 12.5137 16.9583 12.5137C16.401 12.5137 15.9492 12.9655 15.9492 13.5228V16.3035C15.9492 16.8608 16.401 17.3126 16.9583 17.3126C17.1048 17.3126 17.2438 17.2806 17.3694 17.2245C17.0172 17.067 16.7714 16.7142 16.7714 16.3035Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0777 16.3035V13.5229C33.0777 13.1121 33.3235 12.7594 33.6757 12.6018C33.55 12.5457 33.4111 12.5137 33.2646 12.5137C32.7073 12.5137 32.2555 12.9655 32.2555 13.5228V16.3035C32.2555 16.8608 32.7073 17.3126 33.2646 17.3126C33.4111 17.3126 33.5501 17.2806 33.6757 17.2245C33.3235 17.067 33.0777 16.7142 33.0777 16.3035Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9245 16.3035V13.5229C24.9245 13.1121 25.1703 12.7594 25.5225 12.6018C25.3968 12.5457 25.2579 12.5137 25.1114 12.5137C24.5541 12.5137 24.1023 12.9655 24.1023 13.5228V16.3035C24.1023 16.8608 24.5541 17.3126 25.1114 17.3126C25.2579 17.3126 25.3969 17.2806 25.5225 17.2245C25.1703 17.067 24.9245 16.7142 24.9245 16.3035Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.848 16.3035V13.5229C20.848 13.1121 21.0938 12.7594 21.446 12.6018C21.3203 12.5457 21.1814 12.5137 21.0349 12.5137C20.4776 12.5137 20.0258 12.9655 20.0258 13.5228V16.3035C20.0258 16.8608 20.4776 17.3126 21.0349 17.3126C21.1814 17.3126 21.3204 17.2806 21.446 17.2245C21.0938 17.067 20.848 16.7142 20.848 16.3035Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0011 16.3035V13.5229C29.0011 13.1121 29.2469 12.7594 29.5991 12.6018C29.4734 12.5457 29.3346 12.5137 29.188 12.5137C28.6307 12.5137 28.1789 12.9655 28.1789 13.5228V16.3035C28.1789 16.8608 28.6307 17.3126 29.188 17.3126C29.3346 17.3126 29.4735 17.2806 29.5991 17.2245C29.2469 17.067 29.0011 16.7142 29.0011 16.3035Z",
    fill: "#F16480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1281 18.3203L14.0951 18.3203V19.6285L36.1281 19.6285V18.3203Z",
    fill: "#F27D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6748 22.9961L15.5478 22.9961V23.4446L34.6748 23.4446V22.9961Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6748 26.6582L15.5478 26.6582V27.1067L34.6748 27.1067V26.6582Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6748 30.3223L15.5478 30.3223V30.7708L34.6748 30.7708V30.3223Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6748 33.9863H15.5478V34.4348H34.6748V33.9863Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3493 37.6484C32.0953 37.8066 31.8357 37.9562 31.5711 38.097H18.6522C18.3876 37.9562 18.128 37.8065 17.874 37.6484H32.3493Z",
    fill: "#D4648A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_78170",
    x1: 25,
    y1: -0.00195313,
    x2: 25,
    y2: 45.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_78170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.4725,
    height: 27.4725,
    fill: "white",
    transform: "translate(11.3753 12.2324)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalIcon);
export default __webpack_public_path__ + "static/media/journal-icon.977d2e4f22364fa3fd1874b14f789757.svg";
export { ForwardRef as ReactComponent };